import Skeleton from "@components/skeleton/Skeleton";
import React from "react";

import TestIds from "../../testIds";
import { TooltipIconInfo } from "../tooltipIcon";
import { Header, SeparatorStyledFormGroup, Title } from "./FormGroup.styles";

interface IGroupHeaderProps {
    title?: string;
    showLine?: boolean;
    tooltip?: React.ReactElement | string;
    className?: string;
    style?: React.CSSProperties;
    isSkeleton?: boolean;
}

export class GroupHeader extends React.Component<IGroupHeaderProps> {
    render() {
        if (!this.props.title) {
            return null;
        }

        if (this.props.isSkeleton) {
            return <GroupHeaderSkeleton/>;
        }

        return (
            <Header data-testid={TestIds.FormGroupHeader}
                    className={this.props.className}
                    style={this.props.style}>
                {/*todo move title, tooltip and children to Separator*/}
                <Title data-testid={TestIds.Title}>
                    {this.props.title}
                </Title>
                {this.props.tooltip && <TooltipIconInfo>{this.props.tooltip}</TooltipIconInfo>}
                {this.props.children}
                {this.props.showLine && <SeparatorStyledFormGroup/>}
            </Header>
        );
    }
}

const GroupHeaderSkeleton: React.FunctionComponent = () => {
    return (
        <div style={{ display: "flex", gap: "8px", width: "100%", alignItems: "center" }}>
            <Skeleton width={"120px"} height={"16px"}/>
            <Skeleton width={"100%"} height={"2px"}/>
        </div>
    );
};